import React, { useState, useEffect } from "react"
import { Form } from "antd"

import CustomFormItem from "../../../v2-components/Antd/FormItem"
import CustomSwitch from "../../../v2-components/Antd/Switch"
import CustomInput from "../../../v2-components/Antd/Input"
import CustomSelect from "../../../v2-components/Antd/Select"
import CustomButton from "../../../v2-components/Antd/Button"

import { ROLES } from "../constants/index"

import "../styles/common.css"
import "../styles/forms.css"
import "../styles/button.css"

const UpdateUserForm = ({ values = {}, onFinish, loading = false }) => {
    const [form] = Form.useForm()
    const [isEditing, setIsEditing] = useState(false)

    // Actualizar formulario cuando cambian los valores
    useEffect(() => {
        form.setFieldsValue(values)
    }, [values, form])

    // Manejar envío del formulario
    const handleFinish = (updatedValues) => {
        const { email, ...restValues } = updatedValues;
        onFinish({ ...restValues, id: values.id });
        setIsEditing(false);
    }

    // Activar modo edición
    const handleEdit = () => {
        setIsEditing(true)
    }

    // Cancelar edición
    const handleCancel = () => {
        setIsEditing(false)
        form.setFieldsValue(values)
    }

    return (
        <div className="page-container">
            <Form form={form} layout="vertical" onFinish={handleFinish} className="form-container">
                <h2 className="section-title">
                    Datos
                </h2>

                {/* ID - Oculto al usuario */}
                <CustomInput name="id" type="hidden" value={values.id} />

                {/* Correo electrónico */}
                <CustomFormItem
                    label="Correo electrónico"
                    name="email"
                    className="form-item"
                >
                    <CustomInput disabled placeholder="Correo electrónico" />
                </CustomFormItem>

                {/* Primer nombre */}
                <CustomFormItem
                    label="Nombre"
                    name="first_name"
                    rules={[{ required: true, message: "Por favor ingresa el nombre" }]}
                    className="form-item"
                >
                    <CustomInput disabled={!isEditing} placeholder="Nombre" />
                </CustomFormItem>

                {/* Apellido */}
                <CustomFormItem
                    label="Apellido"
                    name="last_name"
                    rules={[{ required: true, message: "Por favor ingresa el apellido" }]}
                    className="form-item"
                >
                    <CustomInput disabled={!isEditing} placeholder="Apellido" />
                </CustomFormItem>

                <h2 className="section-title">
                    Roles
                </h2>

                {/* Roles */}
                <Form.Item
                    label="Rol de usuario"
                    name="roles"
                    rules={[{ required: true, message: "Por favor selecciona un rol" }]}
                    className="form-item"
                >
                    <CustomSelect disabled placeholder="Selecciona un rol">
                        {ROLES.filter((option) => option.value !== "admin").map((option) => (
                            <CustomSelect.Option key={option.key} value={option.value}>
                                {option.label}
                            </CustomSelect.Option>
                        ))}
                    </CustomSelect>
                </Form.Item>

                <h2 className="section-title">
                    Sucursal
                </h2>

                {/* Sucursales */}
                <Form.Item
                    label="Sucursal"
                    name="pharmacy"
                    rules={[{ required: true, message: "Por favor selecciona una sucursal" }]}
                    className="form-item"
                >
                    <CustomSelect
                        placeholder="Selecciona una sucursal"
                        disabled
                    >
                        <CustomSelect.Option key={values.pharmacy} value={values.pharmacy}>
                            {values.pharmacy}
                        </CustomSelect.Option>
                    </CustomSelect>
                </Form.Item>

                <h2 className="section-title">
                    Estado
                </h2>

                {/* Estado de habilitación */}
                <CustomFormItem
                    label="Estado"
                    name="eneable"
                    valuePropName="checked"
                    rules={[{ required: true, message: "Por favor selecciona el estado del usuario" }]}
                    className="form-item"
                >
                    <CustomSwitch disabled={!isEditing} />
                </CustomFormItem>

                {/* Botones de acción */}
                <div className="button-container">
                    {!isEditing ? (
                        <CustomButton className="filled-button" type="primary" onClick={handleEdit} disabled={loading}>
                            Editar
                        </CustomButton>
                    ) : (
                        <>
                            <CustomButton className="plain-button" type="default" onClick={handleCancel} disabled={loading}>
                                Cancelar
                            </CustomButton>
                            <CustomButton className="filled-button" type="primary" onClick={() => form.submit()} loading={loading} disabled={loading}>
                                Guardar
                            </CustomButton>
                        </>
                    )}
                </div>
            </Form>
        </div>
    )
}

export default React.memo(UpdateUserForm)
